<template>
  <div class="section">
    <div class="order-inquiry">
      <div class="guest-lookup-box">
        <h2 class="title">비회원 주문조회</h2>

        <div class="form-wrap">
          <div class="input-group">
            <label for="guestName">주문번호</label>
            <input
              id="guestName"
              v-model="form.orderNumber"
              type="text"
              placeholder="주문번호를 입력해주세요"
              class="input-field"
            />
          </div>

          <button type="button" class="btn btn-lg btn-primary btn-lookup" @click="handleLookup">
            조회하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import Footer from '@/components/Footer.vue';
import api from '@/utils/api.js';
import router from '@/router';

const form = reactive({
  orderNumber: '',
});

const handleLookup = async () => {
  if (!form.orderNumber) {
    alert('주문번호를 입력해주세요.');
    return;
  }
  const response = await api.post('/order.php', {
    mode: 'marketOrderList',
    type: 'G',
    orderNumber: form.orderNumber,
  });

  if (response.data) {
    if (response.data.data.length <= 0) {
      alert('주문내역이 없습니다. 주문번호를 확인해주시기 바랍니다.');
    } else {
      router.push({
        path: '/orderList',
        state: {
          data: JSON.stringify({
            orderNumber: form.orderNumber,
          }),
        },
      });
    }
  }
};
</script>
